
import { defineComponent } from 'vue';
import { adService } from '../AdService';
import store from '@/store';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdListItemCompare',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoggedIn() {
      return store.getters['isLoggedIn'];
    },
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      isLoginModalVisible: false,
      showAnimation: false,
      isLoading: false,
    };
  },
  methods: {
    showLoginModal() {
      this.isLoginModalVisible = true;
    },
    closeLoginModal() {
      this.isLoginModalVisible = false;
    },
    async compare() {
      if (!this.isLoggedIn) {
        this.showLoginModal();
        return;
      }

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      if (this.ad.isCompare) {
        const result = await adService.removeCompare(this.ad.adId);
        if (result.status === 200) {
          this.ad.isCompare = false;
          store.dispatch('compareCount', result.data.count);
        }
      } else {
        const result = await adService.addCompare(this.ad.adId);
        if (result.status === 200) {
          this.showAnimation = true;
          this.ad.isCompare = true;
          store.dispatch('compareCount', result.data.count);

          googleTagManagerService.send({
            event: 'porovnanie_vlozenie',
          });
        }
      }

      this.isLoading = false;
    },
    beforeEnter(el: any) {
      const compareButton = (this.$refs.compareButton as any)?.getBoundingClientRect();

      if (compareButton) {
        const xDist = compareButton?.left;
        const yDist = compareButton?.top;
        el.style.left = `${xDist}px`;
        el.style.top = `${yDist}px`;
        //el.style.transform = 'translate(0,0)';
        //el.style.transform = 'scale(0)';
      }
    },
    enter(el: any, done: any) {
      const compareAnimPosition = (this.$refs.compareAnim as any)?.getBoundingClientRect();

      const headerComparePosition = document.getElementById('header-icon-compare')?.getBoundingClientRect();

      if (compareAnimPosition && headerComparePosition) {
        const xDist = headerComparePosition?.left;
        const yDist = headerComparePosition?.top;

        el.offsetWidth; //If you don't write this sentence, there will be no animation effect, but why not, just write it, offsetTop offsetHeight

        el.style.left = `${xDist}px`;
        el.style.top = `${yDist}px`;
        el.style.transform = 'scale(1)';
        //const xDist = headerComparePosition?.left - compareAnimPosition?.left;
        //const yDist = headerComparePosition?.top - compareAnimPosition?.top;
        //el.style.transform = `translate(${xDist}px,${yDist}px)`;
      }

      done();
    },
    afterEnter() {
      this.showAnimation = !this.showAnimation;
    },
  },
});
